import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import logoBTGLight from "@assets/logo-btg-light.svg";
import { cn } from "@util/helpers";

type PromoteBTGProps = {
  /** This is the classname of the component. */
  className?: string;
};

/**
 * The banner to promote BTG.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=15438-56902&t=yt6ioucb3Irqy0pW-4
 */
const PromoteBTG = ({ className }: PromoteBTGProps): React.ReactElement => {
  return (
    <div
      data-testid="promote-btg-component"
      data-section-name="btg-promo"
      className={cn("track-impression", className)}
    >
      <Link
        to={`${RouteFactory.global}?ref=article-bottom-btg-promo`}
        className="flex flex-col items-center gap-4 bg-btgPromote bg-cover bg-center p-6 lg:flex-row lg:bg-btgPromoteLG"
        reloadDocument
      >
        <img
          src={logoBTGLight}
          width={350}
          height={61}
          title="The Business Times Global Edition"
          className="mx-auto px-4"
        />

        <span className="block text-center lg:ml-auto lg:text-right">
          <p className="mb-2 whitespace-nowrap font-freightSansPro text-lg font-bold leading-120 text-white text-opacity-70">
            Your guide to navigating
            <span className="block text-verticals-btblue">Asia and beyond</span>
            in a new world order
          </p>

          <span className="inline-block rounded-full border-2 border-blue-190 px-6 py-4 text-center font-poppins text-2xs font-semibold leading-150 tracking-5 !text-white !no-underline">
            EXPLORE NOW
          </span>
        </span>
      </Link>
    </div>
  );
};

export default PromoteBTG;
